import { Tooltip } from 'antd';
import { TeamBadge } from '@/components';

interface Team {
  id: string;
  name: string;
  color: string | null;
}

interface TeamListProps {
  items: {
    teams?: Team[];
  };
}

const TeamList: React.FC<TeamListProps> = ({ items }) => {
  if (!items?.teams?.length) return null;

  const teams = items.teams;

  return (
    <div className='shipment-team-list'>
      <TeamBadge
        color={teams[0].color}
        text={teams[0].name}
        tooltipText={teams[0].name}
        truncateLength={10}
      />
      {teams.length > 1 && (
        <Tooltip
          title={teams
            .slice(1)
            .map((t) => t.name)
            .join(', ')}
          placement='top'
        >
          <div style={{ display: 'inline-block', cursor: 'pointer' }}>
            <TeamBadge color={null} text={`+ ${teams.length - 1}`} />
          </div>
        </Tooltip>
      )}
    </div>
  );
};

export default TeamList;
